import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-right"><path d="M6.53463 4.18721C5.38775 3.61264 4 4.42612 4 5.73462V18.2651C4 19.5736 5.38775 20.3871 6.53463 19.8125L19.0404 13.5473C20.3199 12.9062 20.3199 11.0935 19.0404 10.4524L6.53463 4.18721Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowTriangleRight;
